import React from 'react';
import PageHeader from '../components/PageHeader';
import '../css/deansw.css'; // Update the CSS file name

const MBAResultpage = () => {
    return (

        <div class="container">

            <div class="row">

                <p>


                    <h3 align='center'>
                        NATIONAL INSTITUTE OF TECHNOLOGY, WARANGAL
                    </h3>
                    <h4 align='center'>
                        DEPARTMENT OF MANAGEMENT STUDIES
                    </h4>
                    <h5 align='center'><u>M.B.A Admissions - 2025</u>
                    </h5>
                    <p>
                        The personal interviews for the shortlisted candidates were conducted during 19 – 21 May 2025. Based on the CAT/MAT/GMAT score, the performance in Group Discussion and Personal Interview. The following candidates have been provisionally selected for MBA admissions of AY 2025-26 by duly following the roster as per GOI norms.<br />
                        <b> Detailed instructions and the schedule for the remaining phases (if any vacant seats are available) are provided in the attached file. Candidates are advised to strictly follow the instructions mentioned therein.</b>
                    </p>
                    {/* <h5><b>Department of Civil Engineering:</b></h5> */}
                    <table className="table table-bordered">
                        <tbody>

                            <tr>
                                <td>
                                    Sl. No.
                                </td>
                                <td>
                                    Application No.
                                </td>
                                <td>
                                    Name of the Candidate
                                </td>
                            </tr>
                            <tr>
                                <td>1</td><td>MB125MS00007</td><td>Mopuri Tejeswar Reddy</td>
                            </tr>
                            <tr>
                                <td>2</td><td>MB125MS00012</td><td>Anand Sai Varma Pemmadi</td>
                            </tr>
                            <tr>
                                <td>3</td><td>MB125MS00015</td><td>Lav kumar</td>
                            </tr>
                            <tr>
                                <td>4</td><td>MB125MS00017</td><td>Satyaki Saha</td>
                            </tr>
                            <tr>
                                <td>5</td><td>MB125MS00018</td><td>Vankaraboena Pavani</td>
                            </tr>
                            <tr>
                                <td>6</td><td>MB125MS00020</td><td>Sreelekha Lalam</td>
                            </tr>
                            <tr>
                                <td>7</td><td>MB125MS00022</td><td>Prasath A</td>
                            </tr>
                            <tr>
                                <td>8</td><td>MB125MS00043</td><td>Saba Fathima</td>
                            </tr>
                            <tr>
                                <td>9</td><td>MB125MS00047</td><td>Khushi Anant Medigeri</td>
                            </tr>
                            <tr>
                                <td>10</td><td>MB125MS00049</td><td>Ramya Vadlamani</td>
                            </tr>
                            <tr>
                                <td>11</td><td>MB125MS00054</td><td>Neelam Sai Teja</td>
                            </tr>
                            <tr>
                                <td>12</td><td>MB125MS00055</td><td>Moola Vishwachandra Rajender</td>
                            </tr>
                            <tr>
                                <td>13</td><td>MB125MS00056</td><td>Edulakanti Naveen Goud</td>
                            </tr>
                            <tr>
                                <td>14</td><td>MB125MS00060</td><td>Dhritabrata Swarnakar</td>
                            </tr>
                            <tr>
                                <td>15</td><td>MB125MS00067</td><td>Banothu Neeharika Rathod</td>
                            </tr>
                            <tr>
                                <td>16</td><td>MB125MS00072</td><td>Govica SG</td>
                            </tr>
                            <tr>
                                <td>17</td><td>MB125MS00076</td><td>Swati Rekha Parhi</td>
                            </tr>
                            <tr>
                                <td>18</td><td>MB125MS00083</td><td>Nithish R V</td>
                            </tr>
                            <tr>
                                <td>19</td><td>MB125MS00085</td><td>Nikhil Kumar Singh</td>
                            </tr>
                            <tr>
                                <td>20</td><td>MB125MS00093</td><td>Bhuvaneswari Reddy</td>
                            </tr>
                            <tr>
                                <td>21</td><td>MB125MS00100</td><td>Hritik Srivastava</td>
                            </tr>
                            <tr>
                                <td>22</td><td>MB125MS00104</td><td>Samyuktha R.P</td>
                            </tr>
                            <tr>
                                <td>23</td><td>MB125MS00118</td><td>Sachin Guria</td>
                            </tr>
                            <tr>
                                <td>24</td><td>MB125MS00119</td><td>Samya Das</td>
                            </tr>
                            <tr>
                                <td>25</td><td>MB125MS00121</td><td>Ritik Premchand Maurya</td>
                            </tr>
                            <tr>
                                <td>26</td><td>MB125MS00127</td><td>Mudavath Vijay Kumar</td>
                            </tr>
                            <tr>
                                <td>27</td><td>MB125MS00129</td><td>Mohd Azam</td>
                            </tr>
                            <tr>
                                <td>28</td><td>MB125MS00149</td><td>Ravikant Kumar Nirala</td>
                            </tr>
                            <tr>
                                <td>29</td><td>MB125MS00153</td><td>Talari Keerthana</td>
                            </tr>
                            <tr>
                                <td>30</td><td>MB125MS00156</td><td>Priya Pathak</td>
                            </tr>
                            <tr>
                                <td>31</td><td>MB125MS00158</td><td>Sathi Lahari Madhavi Reddy</td>
                            </tr>
                            <tr>
                                <td>32</td><td>MB125MS00165</td><td>Kaushal Thakur</td>
                            </tr>
                            <tr>
                                <td>33</td><td>MB125MS00166</td><td>Khurshid Mainul Tapadar</td>
                            </tr>
                            <tr>
                                <td>34</td><td>MB125MS00186</td><td>Mansi Kumari</td>
                            </tr>
                            <tr>
                                <td>35</td><td>MB125MS00197</td><td>Saswat Sastri</td>
                            </tr>
                            <tr>
                                <td>36</td><td>MB125MS00202</td><td>Mallela Sree Moukthika Kameswari</td>
                            </tr>
                            <tr>
                                <td>37</td><td>MB125MS00205</td><td>Vishnubhotla Durga Sai Rama Vedavyas</td>
                            </tr>
                            <tr>
                                <td>38</td><td>MB125MS00212</td><td>Harbeer Singh</td>
                            </tr>
                            <tr>
                                <td>39</td><td>MB125MS00223</td><td>Nishant Thakur</td>
                            </tr>
                            <tr>
                                <td>40</td><td>MB125MS00225</td><td>Sukoori Tejaswini</td>
                            </tr>
                            <tr>
                                <td>41</td><td>MB125MS00228</td><td>Maluva Prasanthi</td>
                            </tr>
                            <tr>
                                <td>42</td><td>MB125MS00259</td><td>Puja Dhali</td>
                            </tr>
                            <tr>
                                <td>43</td><td>MB125MS00303</td><td>Rajamalla Ananya Tej</td>
                            </tr>
                            <tr>
                                <td>44</td><td>MB125MS00312</td><td>Methuku Krishna Sai Eshwar</td>
                            </tr>
                            <tr>
                                <td>45</td><td>MB125MS00322</td><td>Nair Urmila Unnikrishnan</td>
                            </tr>
                            <tr>
                                <td>46</td><td>MB125MS00324</td><td>Aishwarya Yadav</td>
                            </tr>
                            <tr>
                                <td>47</td><td>MB125MS00325</td><td>Atukuri Kireeti Sai Santhosh</td>
                            </tr>
                            <tr>
                                <td>48</td><td>MB125MS00337</td><td>Anshul Godghate</td>
                            </tr>
                            <tr>
                                <td>49</td><td>MB125MS00342</td><td>Jyoti Singh</td>
                            </tr>
                            <tr>
                                <td>50</td><td>MB125MS00350</td><td>Rose Mary M J</td>
                            </tr>
                            <tr>
                                <td>51</td><td>MB125MS00365</td><td>Mohd Arsalan</td>
                            </tr>
                            <tr>
                                <td>52</td><td>MB125MS00370</td><td>Peddaventharla Joel</td>
                            </tr>
                            <tr>
                                <td>53</td><td>MB125MS00373</td><td>Alwin Alfred Gouda</td>
                            </tr>
                            <tr>
                                <td>54</td><td>MB125MS00375</td><td>Nalumachu Srivatsava</td>
                            </tr>
                            <tr>
                                <td>55</td><td>MB125MS00377</td><td>Chitukula Likhitha</td>
                            </tr>
                            <tr>
                                <td>56</td><td>MB125MS00389</td><td>Jonnalagadda Naga Kiranmayi</td>
                            </tr>
                            <tr>
                                <td>57</td><td>MB125MS00396</td><td>Celina Thomas Chirayil</td>
                            </tr>
                            <tr>
                                <td>58</td><td>MB125MS00398</td><td>Devanshu Upadhyay</td>
                            </tr>
                            <tr>
                                <td>59</td><td>MB125MS00412</td><td>Anuj Kumar Upadhyay</td>
                            </tr>
                            <tr>
                                <td>60</td><td>MB125MS00438</td><td>Bala Chandrika Guttula</td>
                            </tr>
                            <tr>
                                <td>61</td><td>MB125MS00456</td><td>Anisha Raj</td>
                            </tr>
                            <tr>
                                <td>62</td><td>MB125MS00465</td><td>Sugyan Das</td>
                            </tr>
                            <tr>
                                <td>63</td><td>MB125MS00478</td><td>Md Ozair Malik</td>
                            </tr>
                            <tr>
                                <td>64</td><td>MB125MS00505</td><td>Kolakaluri Harika</td>
                            </tr>
                            <tr>
                                <td>65</td><td>MB125MS00507</td><td>Modugumudi Deepthi</td>
                            </tr>
                            <tr>
                                <td>66</td><td>MB125MS00512</td><td>Mudavath Siddu</td>
                            </tr>
                            <tr>
                                <td>67</td><td>MB125MS00515</td><td>Anindita Mukherjee</td>
                            </tr>
                            <tr>
                                <td>68</td><td>MB125MS00518</td><td>Amisha Srivastav</td>
                            </tr>
                            <tr>
                                <td>69</td><td>MB125MS00525</td><td>Ayushi Yadav</td>
                            </tr>
                            <tr>
                                <td>70</td><td>MB125MS00526</td><td>Unukuri Naveen Nava Durga Vamsi Teja</td>
                            </tr>
                            <tr>
                                <td>71</td><td>MB125MS00533</td><td>Nunavath Venkanna</td>
                            </tr>
                            <tr>
                                <td>72</td><td>MB125MS00536</td><td>Aditya Raj</td>
                            </tr>
                            <tr>
                                <td>73</td><td>MB125MS00537</td><td>Nitin</td>
                            </tr>
                            <tr>
                                <td>74</td><td>MB125MS00550</td><td>Bhaktula Prince Jeevan</td>
                            </tr>
                            <tr>
                                <td>75</td><td>MB125MS00560</td><td>Harsita Goswami</td>
                            </tr>
                            <tr>
                                <td>76</td><td>MB125MS00568</td><td>Venkata Rama Krishna Boddu</td>
                            </tr>
                            <tr>
                                <td>77</td><td>MB125MS00587</td><td>Akrati Maheshwari</td>
                            </tr>



                        </tbody>
                    </table><br/>




                    <ol>
                        <li><a href='https://nitw.ac.in/api/static/files/mbaselected2025_2025-5-24-15-3-56.pdf' target='_blank' class="btn btn-primary">1. Instructions and Physical Reporting schedule for the provisionally selected candidates for M.B.A Admissions - 2025.</a></li>

                    </ol>

                    {/* <br></br>
                    <br></br>
                    <b>Associate Dean Admissions      </b>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <b>DEAN, ACADEMIC</b>
                    <br></br>
                    <br></br> */}
                </p>

            </div>
        </div>
    );
};

export default MBAResultpage;